import { useEffect } from 'react';

export function useCounterAnimation() {
  useEffect(() => {
    const cobs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const el    = entry.target;
          const t     = parseFloat(el.dataset.target);
          const suf   = el.dataset.suffix || '';
          const pre   = el.dataset.prefix || '';

          if (t === 0) {
            el.textContent = '0%';
            cobs.unobserve(el);
            return;
          }

          const dur       = 1600;
          const start     = performance.now();
          const isDecimal = String(t).includes('.');

          const tick = (now) => {
            const p    = Math.min((now - start) / dur, 1);
            const ease = 1 - Math.pow(1 - p, 3);
            const val  = ease * t;
            const disp =
              t >= 1000
                ? Math.floor(val).toLocaleString()
                : isDecimal
                ? val.toFixed(1)
                : Math.floor(val);

            el.textContent = pre + disp + suf;
            if (p < 1) requestAnimationFrame(tick);
          };

          tick(start);
          cobs.unobserve(el);
        });
      },
      { threshold: 0.4 }
    );

    document.querySelectorAll('[data-target]').forEach((el) => cobs.observe(el));

    return () => cobs.disconnect();
  }, []);
}
